import React, { Component, Fragment } from 'react';
import { Button } from "../partials";

export default class HeroDeal extends Component {

    render() {
        const { heading, content, button, src } = this.props;

        return (
            <div className="hero-deal">
                <div className="hero-deal__wrap">

                    <div className="hero-deal__content">
                        <h2 className="hero-deal__h">{ heading }</h2>
                        <div className="hero-deal__text">{ content }</div>
                        <div className="hero-deal__cta">
                            <Button
                                href={button.link}
                                title={button.title}
                                chevron={true}
                                modifiers={['solid', 'black']}
                            />
                        </div>
                    </div>

                    <div className="hero-deal__image">
                        <div
                            className="hero-deal__bg"
                        >
                            <span style={{ backgroundImage: `url(${src})` }}></span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
